import * as http from './http'

import { PartyIdentityUserDto } from '@ViewModels/PartyIdentityUserDto'
import { PartySchoolTeacherOptionsModel } from '@ViewModels/PartySchoolTeacherOptionsModel'
import { SubscriptionProductModel } from '@ViewModels/SubscriptionProductModel'

import endpoints from '@ViewModels/ApiEndpoints'

export const getPartyIdentityUser = async (itemId: string): Promise<PartyIdentityUserDto> => {
   const url = `${endpoints.PartyIdentityUserApi}/${itemId}`
   return await http.get(url)
}

export const getUserSubscriptions = async (userId: string) => {
   const url = `${endpoints.PartySubscriptionApi}/${userId}/subscriptions`
   return await http.get(url)
}

export const getPartyHistory = async (userId: string) => {
   const url = `${endpoints.PartyHistoryApi}/user/${userId}`
   return await http.get(url)
}

export const getSchoolTeacherOptions = async (
   userId: string
): Promise<PartySchoolTeacherOptionsModel[]> => {
   const url = `${endpoints.PartySchoolTeacherOptionsApi}/user/${userId}?includeInactive=true`
   return http.get(url)
}

export const savePartyIdentityUser = async (user: PartyIdentityUserDto): Promise<CommitResult> => {
   const url = `${endpoints.PartyIdentityUserApi}`
   return (await http.post(url, user)) as CommitResult
}

export const loginAsUser = async (userId: string): Promise<CommitResult> => {
   const url = `${endpoints.PartyIdentityUserApi}/LoginAsUser/${userId}`
   return (await http.post(url, {})) as CommitResult
}

export const unlockUserAccount = async (userId: string): Promise<any> => {
   const url = `${endpoints.PartyIdentityUserApi}/UnlockAccount/${userId}`
   return (await http.post(url, {})) as CommitResult
}

export const logUserOut = async (userId: string): Promise<any> => {
   const url = `${endpoints.PartyIdentityUserApi}/LogUserOut/${userId}`
   return (await http.post(url, {})) as CommitResult
}

export const markUserEmailConfirmed = async (userId: string): Promise<any> => {
   const url = `${endpoints.PartyIdentityUserApi}/MarkEmailConfirmed/${userId}`
   return (await http.post(url, {})) as CommitResult
}

export const setUserPassword = async (userId: string, password: string): Promise<any> => {
   const url = `${endpoints.PartyIdentityUserApi}/SetPassword/${userId}`
   return (await http.postText(url, password)) as CommitResult
}

export const resetUserPassword = async (userId: string): Promise<any> => {
   const url = `${endpoints.PartyIdentityUserApi}/ResetPassword/${userId}`
   return (await http.post(url, {})) as CommitResult
}

export const changeUserRoles = async (userId: string, data: any): Promise<any> => {
   const url = `${endpoints.PartyIdentityUserApi}/ChangeRole/${userId}`
   return (await http.post(url, data)) as CommitResult
}

export const deletePartyIdentityUser = async (username: string) => {
   const url = `${endpoints.PartyIdentityUserApi}?username=${username}`
   return (await http.del(url)) as CommitResult
}

export const loadSubscriptionProducts = async (): Promise<SubscriptionProductModel[]> => {
   const url = `${endpoints.PartySubscriptionApi}`
   return await http.get(url)
}

export const createPartySubscription = async (data: {}) => {
   const url = `${endpoints.PartySubscriptionApi}/Create`
   return (await http.post(url, data)) as CommitResult
}

export const updatePartySubscription = async (data: {}) => {
   const url = `${endpoints.PartySubscriptionApi}`
   return (await http.post(url, data)) as CommitResult
}

export const getPlansForUserPlanMigration = async (fromTeacherId: string, toTeacherId: string) => {
   const url = `${endpoints.PlanCopyApi}?fromSchoolTeacherId=${fromTeacherId}&toSchoolTeacherId=${toTeacherId}`
   return await http.get(url)
}

export const copyPlanForUserPlanMigration = async (
   planId: string,
   fromTeacherId: string,
   toTeacherId: string
): Promise<CommitResult> => {
   const url = `${endpoints.PlanCopyApi}?planId=${planId}&fromSchoolTeacherId=${fromTeacherId}&toSchoolTeacherId=${toTeacherId}`
   return (await http.post(url, {})) as CommitResult
}
